import React from "react";
import { Avatar } from "antd";
import _ from "lodash";
import { themeColors } from "constant/commonList";

function ChatAvatar(props) {
  const { contactName, contactNumber } = props;
  let content;
  if (contactName) {
    // Remove phone number in parentheses like "(452221222)" from the name
    const cleanName = contactName.replace(/\s*\([^)]*\)\s*$/, "").trim();

    if (cleanName && cleanName.includes(" ")) {
      const parts = cleanName.split(" ").filter(Boolean);
      const firstName = parts[0];
      const lastName = parts.length > 1 ? parts[parts.length - 1] : null;
      if (firstName && lastName) {
        content = (firstName[0] + lastName[0]).toUpperCase();
      } else if (firstName) {
        content = firstName[0].toUpperCase();
      }
    } else if (cleanName) {
      content = cleanName[0]?.toUpperCase() || "";
    } else {
      content = contactNumber && contactNumber.slice(-2);
    }
  } else {
    content = contactNumber && contactNumber.slice(-2);
  }

  function getColor() {
    let num = contactNumber && contactNumber.slice(-1);
    if (num < 5) return themeColors[num];
    else return themeColors[num - 5];
  }

  let style = {
    background: getColor(),
    width: "40px",
    height: "40px",
    fontSize: "18px",
    lineHeight: "42px"
  };

  return (
    <Avatar style={style} className="mx-2 fw-900">
      {content || ""}
    </Avatar>
  );
}

export default ChatAvatar;
